<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="proformas" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="proformaId"
  selectionMode="single" [(selection)]="proforma" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPagination" [rows]="25" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!realtorProfileId && !ownerLeadProfileId && !propertyLeadProfileId) {
        <h1
        style="float: left;margin: 6px;">Proformas</h1>
      }

      <!-- <h1 style="float: left;margin: 6px;">Proformas</h1> -->
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--Create bulk proforma-->
        @if (!ownerLeadProfileId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onOpenGenerateProformaForm()">Generate Proformas</button>
        }

        @if (ownerLeadProfileId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onOpenCopyAndGenerateProforma()">Generate Proforma</button>
        }

        <!--add new-->
        @if (!ownerLeadProfileId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Proforma +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'proformaId', 'in')"></th> -->
        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:70px;" type="text"
      (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th> -->
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th>
        <!-- <input pInputText style="width:70px;" type="text"
        (input)="pt.filter($event.target.value, 'preparedDate', 'in')"> -->
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'CreateByUserVO.firstName', 'in')"></th>
      <th><p-multiSelect [options]="statuses" displaySelectedLabel
      optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'status', 'in')"></p-multiSelect></th>
      <th><p-multiSelect [options]="visibilities" displaySelectedLabel
      optionLabel="name" appendTo="body" (onChange)="pt.filter($event.value, 'visibility', 'in')"></p-multiSelect></th>
      <th><input pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'RealtorProfileVO.firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
      (input)="pt.filter($event.target.value, 'OwnerProfileLeadVO.firstName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="70" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
    </tr>
  }
</ng-template>

<ng-template pTemplate="body" let-proforma>
  <tr [pSelectableRow]="proforma">
    <td>{{proforma.name}}</td>
    <td>{{proforma.customAddress}}</td>
    <td>{{proforma.preparedDate | date:'MM-dd-yyyy'}}</td>
    <td>{{proforma?.createByProfile?.firstName}}</td>
    <td>{{getStatusName(proforma)}}</td>
    <td>{{getVisibilityName(proforma)}}</td>
    <td>{{proforma?.realtorProfile?.firstName}}</td>
    <td>{{proforma?.ownerLeadProfile?.firstName}}</td>
    <td>{{proforma?.expansion?.yrGrossTtlAmnt | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
    <td>{{proforma?.stable?.yrGrossTtlAmnt | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
    <td>{{proforma?.contraction?.yrGrossTtlAmnt | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
    <td>
      <span *ngIf="proforma?.viewCount == null" class="engagement-badge badge-not-viewed">Not Viewed</span>
      <span *ngIf="proforma?.viewCount === 0" class="engagement-badge badge-not-viewed">Not Viewed</span>
      <span *ngIf="proforma?.viewCount >= 1 && proforma?.viewCount <= 2" class="engagement-badge badge-viewed">Viewed {{proforma.viewCount}}&times;</span>
      <span *ngIf="proforma?.viewCount >= 3 && proforma?.viewCount <= 9" class="engagement-badge badge-active">Active {{proforma.viewCount}}&times;</span>
      <span *ngIf="proforma?.viewCount >= 10" class="engagement-badge badge-hot">Hot {{proforma.viewCount}}&times;</span>
    </td>
    <td>{{proforma?.lastViewedAt ? (proforma.lastViewedAt | date:'MM/dd/yy HH:mm') : '—'}}</td>
    <app-tag-join-list-select [tagSource]="70" [tagSourceId]="proforma.proformaId" tagType="4"></app-tag-join-list-select>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proforma)"></i>
      </a>
      @if (proforma.confId) {
        <a pTooltip="Copy public link" tooltipPosition="top">
          <i class="pi pi-link" aria-hidden="true"
          style="color:green; font-size:110%; padding-right:20px; cursor:pointer;" (click)="copyPublicLink(proforma)"></i>
        </a>
      }
      @if (proforma.ownerLeadProfileId) {
        <button pButton icon="pi pi-send" label="Send" styleClass="p-button-sm p-button-text"
          class="p-button-sm p-button-text" style="padding:0.2rem 0.4rem;"
          (click)="sendToProspect(proforma); $event.stopPropagation()"></button>
      }
    </span>
  </td>
</tr>
</ng-template>
</p-table>

<app-bizdev-compose-dialog
  [(visible)]="composeVisible"
  [row]="composeRow"
  (sent)="composeVisible = false">
</app-bizdev-compose-dialog>
